import React from 'react';
import { LayersIcon } from 'lucide-react';
import { Template } from '../lib/data';
import { Card, CardContent } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
interface TemplateCardProps {
  template: Template;
}
export function TemplateCard({
  template
}: TemplateCardProps) {
  return <Card className="group overflow-hidden border-border hover:border-primary/50 hover:shadow-md transition-all duration-300 flex flex-col h-full" data-id="element-181">
      {/* Placeholder Image Area */}
      <div className={`aspect-video w-full bg-gradient-to-br ${template.gradientClass} relative p-3 flex flex-col justify-between`} data-id="element-182">
        <div className="flex justify-between items-start" data-id="element-183">
          <Badge variant="secondary" className="bg-background/90 text-foreground hover:bg-background border-none shadow-sm backdrop-blur-sm" data-id="element-184">
            {template.category}
          </Badge>
        </div>

        {/* Overlay Title for placeholder */}
        <div className="text-center" data-id="element-185">
          <h3 className="text-white font-bold text-xl drop-shadow-md" data-id="element-186">
            {template.title}
          </h3>
        </div>

        <div className="flex justify-between items-end" data-id="element-187">
          <div className="text-xs font-medium text-white/90 bg-black/20 px-2 py-1 rounded backdrop-blur-sm" data-id="element-188">
            {template.bestForTag}
          </div>
        </div>
      </div>

      {/* Content Area */}
      <CardContent className="px-3 py-2.5 flex flex-col flex-grow" data-id="element-189">
        <h3 className="font-semibold text-sm text-foreground mb-1 group-hover:text-primary transition-colors" data-id="element-190">
          {template.title}
        </h3>
        <p className="text-xs text-muted-foreground line-clamp-2 mb-2 flex-grow" data-id="element-191">
          {template.description}
        </p>

        <div className="flex items-center justify-between mt-auto pt-2 border-t border-border" data-id="element-192">
          <div className="flex items-center text-muted-foreground text-xs font-medium" data-id="element-193">
            <LayersIcon className="w-3.5 h-3.5 mr-1" data-id="element-194" />
            {template.stepCount} pages
          </div>
          <Button variant="ghost" size="sm" className="text-primary hover:bg-primary/10 hover:text-primary px-1.5 py-1 h-auto text-xs" data-id="element-195">
            Preview
          </Button>
        </div>
      </CardContent>
    </Card>;
}